module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e1962557"
    }
  }, [_c('b', [_vm._v("SUMMERTIME CORN CHOWDER")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e1963057"
    }
  }, [_c('b', [_c('i', [_vm._v("A basket of warm Buttermilk Biscuits and thickly sliced ham are all that’s needed to complete the menu for a real summertime treat.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1964357"
    }
  }, [_c('b', [_vm._v("Prep: 25 minutes Cook: 35 to 40 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1964857"
    }
  }, [_vm._v("6 medium ears corn, husks and silk removed")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1965157"
    }
  }, [_vm._v("4 slices bacon, cut into ½-inch pieces")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1966257"
    }
  }, [_vm._v("1 medium red onion, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1966557"
    }
  }, [_vm._v("1 jalapeño chile, seeded and finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1967257"
    }
  }, [_vm._v("1 garlic clove, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1967557"
    }
  }, [_vm._v("2 tablespoons all-purpose flour")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1967857"
    }
  }, [_vm._v("½ teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1968757"
    }
  }, [_vm._v("⅛ teaspoon ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1969757"
    }
  }, [_vm._v("1 pound red potatoes (6 medium), cut into "), _c('br'), _vm._v(" ½-inch pieces")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1971057"
    }
  }, [_vm._v("2 cans (14½ ounces each) chicken broth or "), _c('br'), _vm._v(" 3½ cups Chicken Broth")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1973357"
    }
  }, [_vm._v("2 cups half-and-half or light cream")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1973657"
    }
  }, [_vm._v("2 small ripe tomatoes (8 ounces), peeled, "), _c('br'), _vm._v(" seeded, and chopped "), _c('br'), _vm._v(" thinly sliced basil leaves")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e1974757"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" Cut kernels from corncobs (about 3 cups), reserving 3 corncobs; discard remaining corncobs.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1975957"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" In 5-quart Dutch oven, cook bacon over medium heat until browned. With slotted spoon, transfer bacon to paper towels to drain; crumble.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1977357"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" To bacon drippings in Dutch oven, add onion and jalapeño and cook, stirring, until onion is tender, about 5 minutes. Add garlic; cook 1 minute longer. Stir in flour, salt, and pepper; cook, stirring, 1 minute.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1979557"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("4.")])]), _vm._v(" Stir in potatoes, reserved corncobs, broth, and half-and-half; heat to boiling over high heat. Reduce heat; cover and simmer until potatoes are tender, 10 to 15 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1981257"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("5.")])]), _vm._v(" Discard corncobs; stir in reserved corn kernels and heat through. Transfer chowder to warm tureen. Stir in tomatoes and sprinkle with bacon and basil. Makes about 9½ cups or 8 first-course servings.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e1984557"
    }
  }, [_vm._v("Each serving: About 272 calories, 7g protein, 29g carbohydrate, 15g total fat (7g saturated), 30mg cholesterol, 693mg sodium.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781618371621_0057_001",
      "src": "Images/9781618371621_0057_001.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap",
    attrs: {
      "id": "d7e1987657"
    }
  }, [_vm._v("Summertime Corn Chowder")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d685513e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c55_r1.vue
// module id = 231
// module chunks = 0